module.exports = '<svg width="41" height="32" viewBox="0 0 41 32"><path d="M20.402 0C12.352 0 4.658 5.755.333 15.022l-.238.51c-.131.281-.126.734.016 1.01l.254.503C4.966 26.131 12.831 32 20.402 32c7.541 0 15.019-5.488 20.009-14.683 0 0 .133-.242.293-.542.162-.299.167-.786.009-1.088l-.286-.544C35.387 5.518 28.089 0 20.402 0zm0 22.857c-3.728 0-6.761-3.077-6.761-6.857s3.033-6.857 6.761-6.857c3.73 0 6.763 3.077 6.763 6.857s-3.033 6.857-6.763 6.857z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/eye-4.js
// module id = 1137
// module chunks = 14